module.exports = __webpack_public_path__ + "static/4.1ab92933.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/portfolio/4.jpg
// module id = 441
// module chunks = 246384609461072